/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation FallbackRoutePlanCreateMutation($input: [FallbackRoutePlanCreateInput!]!) {
  FallbackRoutePlanCreate(input: $input) {
    id,
    fallbackTimeout,
    message,
    status
  }
}
`
